export function toTop() {
  $(document).on('scroll', toggleToTopButton);
  $(".scrollToTop").on('click', scrollToTop);
}

function scrollToTop() {
  $("html, body").animate({ scrollTop: 0 }, 500);
  return false;
}

function toggleToTopButton() {
  if ($(this).scrollTop() > 200) {
    $(".scrollToTop").addClass("visible");
  } else {
    $(".scrollToTop").removeClass("visible");
  }
}